import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';
import {
  incrementAnswerCounter,
  acceptAnswer,
  editAnswer,
  updateAnswer,
  moderateAnswer} from '../modules/Question-Answers';
import {addComment, showAllComments} from '../modules/Question-Comments';
import answerFormCreator from './AnswerForm';
import CommentList from './CommentList';
import {emitEvent} from '../lib/mz';
import UserComment from './components/UserComment';
import PostControls from './components/PostControls';
import VoteControl from './components/VoteControl';
import AcceptedAnswer from './components/AcceptedAnswer';
import A from './components/A';

@connect(
  (state) => ({
    widget: state.environment.widget,
    widgetType: state.environment.widgetType,
  }),
  {incrementAnswerCounter, acceptAnswer, editAnswer, updateAnswer, addComment, moderateAnswer, showAllComments}
)

// eslint-disable-next-line react/prefer-stateless-function
export default class AnswerRow extends Component {
  static propTypes = {
    questionUserId: PropTypes.number.isRequired,
    question: PropTypes.object.isRequired,
    answer: PropTypes.object.isRequired,
    answerVote: PropTypes.object,
    user: PropTypes.object,
    incrementAnswerCounter: PropTypes.func.isRequired,
    acceptAnswer: PropTypes.func.isRequired,
    updateAnswer: PropTypes.func.isRequired,
    editAnswer: PropTypes.func.isRequired,
    addComment: PropTypes.func.isRequired,
    moderateAnswer: PropTypes.func.isRequired,
    showAllComments: PropTypes.func.isRequired,
    lastItem: PropTypes.bool,
    widget: PropTypes.bool.isRequired,
    widgetType: PropTypes.string.isRequired,
  };

  render() {
    const {answer, question, lastItem, answerVote, user, questionUserId, widget, widgetType} = this.props;

    const questionDLM = question.deleted || question.moderated || question.locked;
    const answerM = answer.moderated;
    const answerDM = answer.moderated || answer.deleted;
    const disableEdit = questionDLM || answerDM;
    const userIsQuestionAuthor = user && questionUserId === user.id;
    const isUsersAnswer = user && answer.user_id === user.id;
    const isEditingAnswer = Boolean(answer.editing);
    const userIsModerator = user && user.canModerate;
    const canEdit = isUsersAnswer || userIsModerator;
    const voteButtonDisabled = isUsersAnswer;
    const voteStatus = answerVote && answerVote.vote ? answerVote.vote : '';

    const mzClick = (eventTitle) =>
      emitEvent('CLICK', {eventTitle, id: answer.id, module: {type: widgetType}});

    const voteUp = (e) => {
      e.preventDefault();
      if (isUsersAnswer) return;
      mzClick('answer-vote-up');
      this.props.incrementAnswerCounter({answer_id: answer.id, question_id: answer.question_id, type: 'votes_up'});
    };

    const voteDown = (e) => {
      e.preventDefault();
      if (isUsersAnswer) return;
      mzClick('answer-vote-down');
      this.props.incrementAnswerCounter({answer_id: answer.id, question_id: answer.question_id, type: 'votes_down'});
    };

    const accept = (e) => {
      e.preventDefault();
      if (!userIsQuestionAuthor) return;
      mzClick('answer-accept');
      this.props.acceptAnswer(answer, !answer.accepted_answer);
    };

    const onEditClick = (e) => {
      e.preventDefault();
      if (!canEdit) return;
      mzClick('answer-edit');
      this.props.editAnswer(answer, true);
    };

    const onDeleteClick = (e) => {
      e.preventDefault();
      if (!canEdit) return;
      mzClick('answer-delete');
      this.props.updateAnswer({id: answer.id, deleted: true});
    };

    const onUndoDeleteClick = (e) => {
      e.preventDefault();
      if (!canEdit) return;
      mzClick('answer-delete-undo');
      this.props.updateAnswer({id: answer.id, deleted: false});
    };

    const onModerateClick = (e) => {
      e.preventDefault();
      mzClick('answer-moderate');
      this.props.moderateAnswer({id: answer.id, moderated: true});
    };

    const onUndoModerateClick = (e) => {
      e.preventDefault();
      mzClick('answer-moderate-undo');
      this.props.moderateAnswer({id: answer.id, moderated: false});
    };

    const onAddCommentClick = (e) => {
      e.preventDefault();
      mzClick('answer-add-comment');
      this.props.addComment('answer', answer.id, true);
    };

    const onCloseCommentClick = (e) => {
      e.preventDefault();
      mzClick('answer-close-comment');
      this.props.addComment('answer', answer.id, false);
    };

    const onLoadOlderCommentsClick = () => {
      this.props.showAllComments({parentType: 'answer', parentId: answer.id, showComments: true});
    };

    const deletedStyle = answer.deleted ? {textDecoration: 'line-through'} : null;
    const moderatedFlag = answer.moderated ? ' [moderated] ' : null;

    const acceptComponent = widgetType === 'comment' || disableEdit || !userIsQuestionAuthor ? null : (
      <div className="t-answer-accept-btn link link--colored" onClick={accept}>
        { answer.accepted_answer ? 'Cancel accept answer' : 'Accept answer' }
      </div>);

    const commentCount = answer.comments
      ? `${answer.comments.length} comments`
      : (<A className="t-comment-add" onClick={onAddCommentClick}>
          Add comment
        </A>);

    const editAnswerButton = canEdit && !disableEdit && !answer.deleted ? (
      <div className="t-answer-edit-btn link link--colored" onClick={onEditClick}>
        Edit
      </div>
    ) : null;

    const deleteAnswerButton = canEdit && !answerM && !answer.deleted ? (
      <div className="t-answer-delete-btn link link--colored" onClick={onDeleteClick}>
        Delete
      </div>
    ) : null;

    const undeleteAnswerButton = canEdit && !answerM && answer.deleted ? (
      <div className="t-answer-undelete-btn link link--colored" onClick={onUndoDeleteClick}>
        Undo Delete
      </div>
    ) : null;

    const moderateAnswerButton = userIsModerator && !answer.moderated ? (
      <div className="t-answer-moderate-btn link link--colored" onClick={onModerateClick}>
        Moderate
      </div>
    ) : null;

    const undoModerateAnswerButton = userIsModerator && answer.moderated ? (
      <div className="t-answer-unmoderate-btn link link--colored" onClick={onUndoModerateClick}>
        Un-moderate
      </div>
    ) : null;

    const AnswerForm = isEditingAnswer ? answerFormCreator(`answer-${answer.id}`) : null;

    const answerComponent = isEditingAnswer ? (
      <UserComment userId={user.id} username={user.username} when={user.createdHuman} showText={false}>
        <AnswerForm
          isUsersQuestion={userIsQuestionAuthor}
          answer={answer}
          question={question}
          widget={widget}
          widgetType={widgetType}
        />
      </UserComment>
    ) : (
      <div>
        <UserComment userId={answer.user_id} username={answer.username} when={answer.createdHuman}>
          <div
            style={deletedStyle}
            dangerouslySetInnerHTML={{__html: answer.content_rendered}}
          />
          <PostControls>
            {commentCount}
            {moderatedFlag}
            {editAnswerButton}
            {deleteAnswerButton}
            {undeleteAnswerButton}
            {moderateAnswerButton}
            {undoModerateAnswerButton}
            {acceptComponent}
          </PostControls>
        </UserComment>
        <CommentList
          question={question}
          answer={answer}
          comments={answer.comments}
          user={user}
          showAllComments={answer.showComments}
          onLoadOlderCommentsClick={onLoadOlderCommentsClick}
          onAddCommentClick={onAddCommentClick}
          onCloseCommentClick={onCloseCommentClick}
        />
      </div>
    );
    const acceptedAnswerItemCss = answer.accepted_answer ? 'answer-item--accepted-answer' : '';
    const answerItemCss = lastItem ? 'answer-item' : `answer-item answer-item--seperator ${acceptedAnswerItemCss}`;
    return (
      <div className="posting-grid">
        <div className="posting-grid__controls">
          { answer.accepted_answer &&
            <div className="margin-bottom-xs">
              <AcceptedAnswer text="Accepted" />
            </div> }
          <VoteControl
            votesType="answer"
            value={answer.votes_total}
            onVoteUpClick={disableEdit ? null : voteUp}
            onVoteDownClick={disableEdit ? null : voteDown}
            isDisabled={voteButtonDisabled}
            voteStatus={voteStatus}
          />
        </div>
        <div className="posting-grid__content">
          <div className={answerItemCss}>
            <div className="answer-item__body">
              {answerComponent}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
